export const OPPORTUNITY_PREFIX_SIZE = 5;
export const HIGH_CONFIDENCE_MIN = 0.66;
export const MEDIUM_CONFIDENCE_MIN = 0.33;
export const PULSE_OPPORTUNITIES_VIEW_EVENT_TYPE = 'widget_view';
export const PULSE_OPPORTUNITIES_ENTITY_NAME = 'pulse_opportunities';
export const PULSE_OPPORTUNITY_ROW_BI_NAME = 'pulse_opportunity';
export const ACTION_BI_NAME_BY_KIND = {
    stale_price: 'pulse_action_stale_price',
    recurring_adhoc: 'pulse_action_recurring_adhoc',
    cross_sell: 'pulse_action_cross_sell',
    discount_leak: 'pulse_action_discount_leak'
};
